import React from 'react';
import ProfileCard, { ProfileListing } from './ProfileCard';
import './ProfileGrid.scss';

interface ProfileGridProps {
  profiles: ProfileListing[];
  loading?: boolean;
  onBuyClick: (profile: ProfileListing) => void;
}

const ProfileGrid: React.FC<ProfileGridProps> = ({ profiles, loading, onBuyClick }) => {
  if (loading) {
    return (
      <div className="profile-grid">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="profile-card-skeleton">
            <div className="skeleton-avatar"></div>
            <div className="skeleton-content">
              <div className="skeleton-line skeleton-title"></div>
              <div className="skeleton-line skeleton-subtitle"></div>
              <div className="skeleton-stats">
                <div className="skeleton-line skeleton-stat"></div>
                <div className="skeleton-line skeleton-stat"></div>
              </div>
              <div className="skeleton-footer">
                <div className="skeleton-line skeleton-price"></div>
                <div className="skeleton-button"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (profiles.length === 0) {
    return (
      <div className="profile-grid-empty">
        <div className="empty-icon">🔍</div>
        <h3>No profiles found</h3>
        <p>Try adjusting your filters or check back later</p>
      </div>
    );
  }

  return (
    <div className="profile-grid">
      {profiles.map((profile) => (
        <ProfileCard key={profile.id} profile={profile} onBuyClick={onBuyClick} />
      ))}
    </div>
  );
};

export default ProfileGrid;
